import React, { useState, useEffect } from "react";
import * as clinicApi from "../../../api/clinicApi";
import { toast } from "react-toastify";
import { ClinicsForm } from "../../forms/Master/ClinicsForm";
import PropTypes from "prop-types";
import { showDeleteConfirm } from "../../common/ConfirmationModal";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function ClinicPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [clinics, setClinics] = useState([]);
  const [rowSelected, setRowSelected] = useState({});
  const location = useLocation();
  let defaultPagination = location.state
    ? location.state.currentPage
      ? location.state.currentPage
      : 1
    : 1;
  const [currentPage, setCurrentPage] = useState(defaultPagination);

  useEffect(getClinics, []);

  function getClinics() {
    clinicApi
      .getAllClinics()
      .then((result) => {
        setIsLoading(false);
        setClinics(result);
      })
      .catch((error) => {
        setIsLoading(false);
        setClinics([]);
        showErrorMessage(t("general.fail_to_load_record") + error.message);
      });
  }

  function addNewItem() {
    history("/home/clinics/clinic", {
      state: { currentPage: currentPage },
    });
  }

  function editItem(clinicKey) {
    history("/home/clinics/clinic/" + clinicKey, {
      state: { currentPage: currentPage },
    });
  }

  function onDelete(clinicKey) {
    showDeleteConfirm("Clinic", clinicKey, deleteClinic, t);
  }

  function deleteClinic(clinicKey) {
    setIsLoading(true);
    clinicApi
      .deleteClinic(clinicKey)
      .then(() => {
        const newData = clinics.filter((item) => item.ClinicKey !== clinicKey);
        setClinics(newData);
        setIsLoading(false);
        toast.success(t("general.record_deleted_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_delete_record") + error.message);
      });
  }

  function showErrorMessage(message) {
    toast.error(message);
  }

  function onRowSelected(value) {
    if (value.UpdatedDate) {
      value.UpdatedOn = value.UpdatedDate;
    }
    if (value.CreatedDate) {
      value.CreatedOn = value.CreatedDate;
    }
    setRowSelected(value);
  }

  return (
    <ClinicsForm
      isLoading={isLoading}
      clinics={clinics}
      onAdd={addNewItem}
      onEdit={editItem}
      onDelete={onDelete}
      onRowSelected={onRowSelected}
      rowSelected={rowSelected}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
    />
  );
}

ClinicPage.propTypes = {
  history: PropTypes.func.isRequired,
};
